import React from 'react';

type SaveIconProps = {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
};

export const SaveIcon: React.FC<SaveIconProps> = ({
  color = 'black',
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.85017 3.00004H12.6684C12.8365 3.00004 12.9873 3.06912 13.0967 3.17965L16.8244 6.90759C16.9407 7.02503 17 7.17815 17 7.33185V15.1498C17 16.1699 16.1694 17 15.1499 17H4.85011C3.83067 17 3 16.1693 3 15.1498V4.85019C3 3.83013 3.83069 3.00004 4.85017 3.00004ZM11.7266 4.20027V6.89267C11.7266 7.22424 11.4584 7.49249 11.1262 7.49249H6.34217C6.01176 7.49249 5.74294 7.22424 5.74294 6.89267V4.20027H4.85014C4.49325 4.20027 4.20084 4.49271 4.20084 4.85019V15.1498C4.20084 15.5073 4.49326 15.7997 4.85014 15.7997H5.74294V11.5307C5.74294 11.1997 6.01118 10.9308 6.34217 10.9308H13.1657C13.4978 10.9308 13.7661 11.1997 13.7661 11.5307V15.7997H15.1505C15.5074 15.7997 15.7998 15.5067 15.7998 15.1498V7.5806L12.4196 4.2003L11.7266 4.20027ZM6.94196 4.20027V6.29274H10.5269V4.20027H6.94196ZM12.5646 12.131H6.94196V15.7997H12.5646V12.131Z"
      fill={color}
    />
  </svg>
);
